import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import './TicTacToe.css';

const TicTacToe = () => {
  const [board, setBoard] = useState(Array(9).fill(null));
  const [isXNext, setIsXNext] = useState(true);
  const [winner, setWinner] = useState(null);

  const calculateWinner = (squares) => {
    const lines = [
      [0, 1, 2], [3, 4, 5], [6, 7, 8], // rows
      [0, 3, 6], [1, 4, 7], [2, 5, 8], // columns
      [0, 4, 8], [2, 4, 6] // diagonals
    ];
    
    for (let i = 0; i < lines.length; i++) {
      const [a, b, c] = lines[i];
      if (squares[a] && squares[a] === squares[b] && squares[a] === squares[c]) {
        return squares[a];
      }
    }
    return null;
  };

  const handleClick = (index) => {
    if (board[index] || winner) return;
    
    const newBoard = [...board];
    newBoard[index] = isXNext ? 'X' : 'O';
    setBoard(newBoard);
    setIsXNext(!isXNext);
    
    const gameWinner = calculateWinner(newBoard);
    if (gameWinner) {
      setWinner(gameWinner);
    }
  };

  const resetGame = () => {
    setBoard(Array(9).fill(null));
    setIsXNext(true);
    setWinner(null);
  };

  const renderSquare = (index) => (
    <button
      key={index}
      className="square"
      onClick={() => handleClick(index)}
    >
      {board[index]}
    </button>
  );

  const isBoardFull = board.every(square => square !== null);
  const gameStatus = winner 
    ? `Winner: ${winner}` 
    : isBoardFull 
    ? "It's a tie!" 
    : `Next player: ${isXNext ? 'X' : 'O'}`;

  return (
    <div className="game-container">
      <div className="game-header">
        <h1 className="game-title-header">⭕ Tic Tac Toe</h1>
        <div className="game-instructions">
          Click on any empty square to place your mark. Get three in a row to win!
        </div>
      </div>

      <div className="game-board">
        <div className="score-display">{gameStatus}</div>
        
        <div className="game-play-area">
          <div className="tic-tac-toe-board">
            {Array(9).fill(null).map((_, index) => renderSquare(index))}
          </div>
        </div>

        <div className="game-controls">
          <button className="btn btn-primary" onClick={resetGame}>
            Reset Game
          </button>
          <Link to="/" className="btn btn-secondary">
            Back to Home
          </Link>
        </div>
      </div>
    </div>
  );
};

export default TicTacToe;